import { ComponentOptions, reactive, ref, watch } from 'vue';
import ICompanyInfo from "./compnay.interface";
import * as VMask from "vanilla-masker";
import useCompanyStore from '../stores/company.store';
import CompanyService from './company.service';
import { CompanyInfoEnum } from '../stores/company.enum';

export default new class CompanyComponent implements ComponentOptions {
  private companyService: CompanyService;
  //86 112 595 427
  fields = reactive({ Number: '', Name: '' });
  public hasError = reactive({ Number: false, Name: false });
  public isValid = reactive({ Number: false, Name: false });
  public isEnabled = ref<boolean>(false);
  public inputDefaultClass = {
    'input-group': true,
    'mb-3': true,
  };

  public activeLoader = ref<boolean>(false);

  async validateNumber() {
    const companyNumber = this.fields.Number.replaceAll(/\s/g, '');

    if (companyNumber.length > 10) {
      this.companyService = new CompanyService(Number(companyNumber));
      this.hasError.Number = false;
      this.activeLoader.value = true;
      const info: ICompanyInfo = await this.companyService.getInformation();
      this.activeLoader.value = false;
      this.isValid.Number = info.AbnStatus == "Active";
      this.hasError.Number = !this.isValid.Number;
      // if (this.isValid.Number) {
      //   this.hasError.Number = false;
      // } else {
      //   this.hasError.Number = true;
      // }
      this.isEnabled.value = this.isValid.Name && this.isValid.Number;
    }
  }

  maskCompanyNumber(): void {
    this.fields.Number = VMask.toPattern(this.fields.Number, '99 999 999 999').trim();
  }

  validateName(): void {
    // this.companyStore = ;
    // this.isValid.Name = this.fields.Name.length >= 3;
    const regexName = /^[A-Za-z][A-Za-z0-9&_@\s]*$/;
    if (this.fields.Name.length >= 3 && regexName.test(this.fields.Name)) {
      this.isValid.Name = true;
      this.hasError.Name = false;
    } else {
      this.isValid.Name = false;
      this.hasError.Name = true;
    }
    this.isEnabled.value = this.isValid.Name && this.isValid.Number;
  }
  store() {
    const companyStore = useCompanyStore();
    companyStore.store(CompanyInfoEnum.CompanyName, this.fields['Name']);
    companyStore.store(CompanyInfoEnum.CompanyNumber, this.fields['Number']);

  }

}


